import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "absolute bg-yellow-50 z-50 p-4 right-0 left-0 m-4",
  style: {"box-shadow":"var(--black100) 4px 4px 7px 2px","border-radius":"5px"}
}
const _hoisted_2 = { class: "mt-2 flex flex-wrap" }
const _hoisted_3 = { class: "debug-chips" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Progress: ", -1)
const _hoisted_5 = { class: "debug-chips" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "isValid: ", -1)
const _hoisted_7 = { class: "debug-chips" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "isRequired: ", -1)
const _hoisted_9 = { class: "debug-chips" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "currentInput: ", -1)
const _hoisted_11 = { class: "debug-chips" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "computedDetectorSetup: ", -1)
const _hoisted_13 = { class: "debug-chips" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "isShowDetectorSetup: ", -1)
const _hoisted_15 = { class: "debug-chips" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "mangels: ", -1)
const _hoisted_17 = { class: "debug-chips" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "mode: ", -1)
const _hoisted_19 = { class: "debug-chips" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "print: ", -1)
const _hoisted_21 = {
  key: 0,
  style: {"max-height":"350px"}
}
const _hoisted_22 = {
  key: 1,
  style: {"max-height":"350px"}
}
const _hoisted_23 = {
  key: 2,
  style: {"max-height":"350px"}
}
const _hoisted_24 = { class: "flex flex-wrap" }
const _hoisted_25 = { class: "debug-chips" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", null, "isShowDetectorSetup: ", -1)
const _hoisted_27 = { class: "debug-chips" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "isFired: ", -1)
const _hoisted_29 = { class: "debug-chips" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, "isTriggered: ", -1)
const _hoisted_31 = { class: "debug-chips" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "mängel modal mode: ", -1)
const _hoisted_33 = { class: "debug-chips" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "currentLogicElement item path: ", -1)
const _hoisted_35 = { class: "debug-chips" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "currentLogicElement found?: ", -1)
const _hoisted_37 = { class: "debug-chips" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "currentLogicElement current input: ", -1)
const _hoisted_39 = { class: "debug-chips" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "currentLogicElement modal mode: ", -1)
const _hoisted_41 = { class: "debug-chips" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", null, "print mangel: ", -1)
const _hoisted_43 = { class: "debug-chips" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "print currentLogicElement: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("strong", null, _toDisplayString(_ctx.frage.getTitle()), 1),
    _createTextVNode(),
    _createVNode(_component_a_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Close ")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.frage.path), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.getProgress()), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.isValid()), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.isRequired()), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.getCurrentInput()), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.isComputedDetectorSetup), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.isShowDetectorSetup), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("span", null, _toDisplayString(_ctx.frage.mangels?.length), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createTextVNode(_toDisplayString(_ctx.frage.mode), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = () => _ctx.frage.print())
        }, {
          default: _withCtx(() => [
            _createTextVNode(" print ")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_button, {
      class: "mt-2",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showJson = _ctx.showJson === 'frage' ? undefined : 'frage'))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.showJson === 'frage' ? 'Hide ' : 'Show') + " Frage Json ", 1)
      ]),
      _: 1
    }),
    _createTextVNode(" |  "),
    _createVNode(_component_a_button, {
      class: "mt-2",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showJson = _ctx.showJson === 'mangeljson' ? undefined : 'mangeljson'))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.showJson === 'mangeljson' ? 'Hide ' : 'Show') + " Mangel Json ", 1)
      ]),
      _: 1
    }),
    _createTextVNode(" |  "),
    _createVNode(_component_a_button, {
      class: "mt-2",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showJson = _ctx.showJson === 'mangel' ? undefined : 'mangel'))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.showJson === 'mangel' ? 'Hide ' : 'Show') + " Maengel Values ", 1)
      ]),
      _: 1
    }),
    (_ctx.showJson === 'frage')
      ? (_openBlock(), _createElementBlock("pre", _hoisted_21, _toDisplayString(_ctx.frageJson), 1))
      : _createCommentVNode("", true),
    (_ctx.showJson === 'mangeljson')
      ? (_openBlock(), _createElementBlock("pre", _hoisted_22, _toDisplayString(_ctx.frage.mangels?.map(el => el.toClassJson())), 1))
      : _createCommentVNode("", true),
    (_ctx.showJson === 'mangel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frage.mangels, (m, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "mt-2"
            }, [
              _createElementVNode("div", null, _toDisplayString(m.titel()), 1),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createTextVNode(_toDisplayString(m.isFireDetectorSetup), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createTextVNode(_toDisplayString(m.isFired()), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createTextVNode(_toDisplayString(m.isTriggered), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createTextVNode(_toDisplayString(m.mode), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createTextVNode(_toDisplayString(m.mangellogik?.currentPath), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createTextVNode(_toDisplayString(!!m.mangellogik?.currentLogicElement), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createTextVNode(_toDisplayString(!!m.mangellogik?.currentLogicElement?.getCurrentInput()), 1)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createTextVNode(_toDisplayString(m.mangellogik?.currentLogicElement?.mode || 'undefined'), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode(_component_a_button, {
                    onClick: () => m.print()
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" print ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_a_button, {
                    onClick: () => m.mangellogik?.currentLogicElement?.print()
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" print ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}